import { render, staticRenderFns } from "./BackofficeMedicamento.vue?vue&type=template&id=a74fa5a8"
import script from "./BackofficeMedicamento.vue?vue&type=script&lang=ts"
export * from "./BackofficeMedicamento.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports